import { createContext } from 'react';
import { type AuthContextValue } from './types';
import type { User } from './api';

export const AuthContext = createContext<AuthContextValue>({
  isAuthenticated: false,
  signIn: () => undefined,
  signOut: () => undefined,
  user: null,
  isLoading: true,
});

export const CYNTHIA_DIALOG_ROUTE = '/cynthia-dialog';
export const DEFAULT_AUTH_REDIRECT_ROUTE = '/vacancy-list';
export const SURFER_WELCOME_PENDING_KEY = 'surferWelcomePending';

export const setSurferWelcomePending = () => {
  sessionStorage.setItem(SURFER_WELCOME_PENDING_KEY, '1');
};

export const clearSurferWelcomePending = () => {
  sessionStorage.removeItem(SURFER_WELCOME_PENDING_KEY);
};

export const isSurferWelcomePending = () =>
  !!sessionStorage.getItem(SURFER_WELCOME_PENDING_KEY);

export const isSurferUser = (user: Pick<User, 'company'>) =>
  user.company.isSurfer;

export const getPostAuthRedirectPath = (user: Pick<User, 'company'>) =>
  isSurferUser(user) ? CYNTHIA_DIALOG_ROUTE : DEFAULT_AUTH_REDIRECT_ROUTE;
